export default (data) => JSON.parse(JSON.stringify(data, (k, v) => v === undefined ? null : v))